import { http, HttpResponse } from 'msw'

import { allAllergens } from 'app/mocks/data/catalogue/products/allergens'

import { api } from 'app/utils/constants'

import { CategoryProductRequest } from 'app/types/catalogue/product/category'

export const getAllAllergens = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.products.allergens.LIST}`,
    () => {
        return HttpResponse.json<CategoryProductRequest>({
            results: allAllergens,
        })
    },
)
